var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStranger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.667A6.667 6.667 0 1012 .334a6.667 6.667 0 000 13.333zM12 2a5 5 0 110 10 5 5 0 010-10zM20.334 15.333H3.666a3.333 3.333 0 00-3.334 3.334v15h23.334v-15a3.334 3.334 0 00-3.334-3.334zM22 32H2V18.667A1.667 1.667 0 013.667 17h16.666A1.667 1.667 0 0122 18.667V32z",
    fill: "#1998D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.767 27.867a1.166 1.166 0 00-1.167 1.266 1.149 1.149 0 001.167 1.2 1.134 1.134 0 001.15-1.2 1.166 1.166 0 00-1.15-1.266zM12.167 18.667a4.232 4.232 0 00-2.667 1v1.75a3.333 3.333 0 012.233-.984c.967 0 1.667.384 1.667 1.367 0 .733-.433 1.3-1.4 2.1a2.8 2.8 0 00-.966 2.583h1.416a2.15 2.15 0 01.934-1.983c1.566-1.133 1.933-2 1.933-3.067.017-1.85-1.133-2.766-3.15-2.766z",
    fill: "#1998D5"
  })));
}
export default SvgStranger;